import { DateTime } from "luxon";

export function expiresSoon(
  dateTime: undefined | string | DateTime | number,
): boolean {
  if (dateTime === undefined) {
    return false;
  }

  if (typeof dateTime === "number") {
    dateTime = DateTime.fromSeconds(dateTime);
  }

  if (typeof dateTime === "string") {
    dateTime = DateTime.fromISO(dateTime);
  }

  const now = DateTime.now();
  return dateTime < now.plus({ days: 30 });
}

export function setOffset(q: URLSearchParams, milliseconds: number): void {
  if (milliseconds !== null && milliseconds !== undefined) {
    q.set("offset_ms", milliseconds.toString());
    localStorage.setItem("last_offset_ms", milliseconds.toString());
  }
}
